<p-dialog 
  [(visible)]="visible" 
  [modal]="true" 
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '800px', maxWidth: '95vw' }"
  (onHide)="closeModal()">
  
  <ng-template pTemplate="header">
    <div class="qr-modal-header">
      <h3>Print Asset QR Code</h3>
    </div>
  </ng-template>

  <div class="qr-modal-content" *ngIf="!isLoading && qrData">
    <div class="qr-modal-layout">
      <!-- Left: Preview -->
      <div class="qr-preview-section">
        <div class="qr-preview-label">Preview</div>
        <div class="qr-preview-card" id="qr-print-preview"
             [style.width.px]="selectedSize.width"
             [style.minHeight.px]="selectedSize.height">
          <div class="qr-logo">
            <ng-container *ngIf="qrData?.company_logo; else defaultLogo">
              <img [src]="qrData.company_logo" alt="Logo" style="height: 20px; width: auto; object-fit: contain;">
            </ng-container>
            <ng-template #defaultLogo>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L2 7l10 5 10-5-10-5z" fill="#10B981"/>
                <path d="M2 17l10 5 10-5" stroke="#10B981" stroke-width="2"/>
                <path d="M2 12l10 5 10-5" stroke="#10B981" stroke-width="2"/>
              </svg>
            </ng-template>
            <span class="qr-logo-text" [style.fontSize.px]="selectedSize.fontSize.title">{{ qrData?.company_name || 'NuvertOS' }}</span>
          </div>
          
          <img [src]="getQRCodeUrl()" 
               alt="QR Code" 
               class="qr-image"
               [width]="selectedSize.qrSize" 
               [height]="selectedSize.qrSize">
          
          <div class="qr-fields-display">
            <ng-container *ngFor="let field of getSelectedFields()">
              <div class="qr-field-value" 
                   [style.fontSize.px]="selectedSize.fontSize.info"
                   *ngIf="getFieldValue(field.key)">
                {{ getFieldValue(field.key) }}
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Right: Options -->
      <div class="qr-options-section">
        <!-- Size Selection -->
        <div class="qr-option-group">
          <div class="qr-option-label">Size</div>
          <div class="qr-size-buttons">
            <button *ngFor="let size of sizes"
                    type="button"
                    class="qr-size-btn"
                    [class.selected]="selectedSize.name === size.name"
                    (click)="selectSize(size)">
              {{ size.name }}
            </button>
          </div>
        </div>

        <!-- Field Selection -->
        <div class="qr-option-group">
          <div class="qr-option-label">Show On QR Code</div>
          <div class="qr-fields-list" cdkDropList (cdkDropListDropped)="onFieldDrop($event)">
            <div *ngFor="let field of fields" 
                 class="qr-field-item"
                 cdkDrag>
              <div class="qr-drag-handle" cdkDragHandle>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="4" cy="4" r="1.5" fill="#9CA3AF"/>
                  <circle cx="4" cy="8" r="1.5" fill="#9CA3AF"/>
                  <circle cx="4" cy="12" r="1.5" fill="#9CA3AF"/>
                  <circle cx="8" cy="4" r="1.5" fill="#9CA3AF"/>
                  <circle cx="8" cy="8" r="1.5" fill="#9CA3AF"/>
                  <circle cx="8" cy="12" r="1.5" fill="#9CA3AF"/>
                </svg>
              </div>
              <p-checkbox [(ngModel)]="field.selected" [binary]="true"></p-checkbox>
              <span class="qr-field-label">{{ field.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div class="qr-loading" *ngIf="isLoading">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
    <p>Loading QR data...</p>
  </div>

  <ng-template pTemplate="footer">
    <div class="qr-modal-footer">
      <div class="qr-print-count" *ngIf="qrData">
        QR Code Printed {{ qrData.qr_print_count }} times already
      </div>
      <p-button 
        label="Print" 
        icon="pi pi-print" 
        (onClick)="print()"
        [loading]="isPrinting"
        [disabled]="!qrData || isLoading">
      </p-button>
    </div>
  </ng-template>
</p-dialog>
